'use strict';

/**
 *
 * @name: navigationAnalytics
 *
 */

function NavigationAnalyticsFactory($analytics) {

  'ngInject';

  function myAccount(label) {

    var properties = {
      eventAction: 'My account',
      eventPoints: 0,
      attributes: {
        label: label
      }
    };

    return $analytics.eventTrack('Customer account', properties);
  }

  function shortcut(label) {

    var properties = {
      eventAction: 'Shortcut',
      eventPoints: 0,
      attributes: {
        label: label
      }
    };

    return $analytics.eventTrack('Customer account', properties);
  }

  function taxonomyNavigation(label) {

    var properties = {
      eventAction: 'Horizontal Menu',
      attributes: {
        label: label
      }
    };

    return $analytics.eventTrack('Main navigation', properties);
  }

  return {
    taxonomyNavigation: taxonomyNavigation,
    myAccount: myAccount,
    shortcut: shortcut
  };
}

export default NavigationAnalyticsFactory;



// WEBPACK FOOTER //
// ./app/components/nn-navigation/nn-navigation-analytics.factory.js